<script lang="ts">
  import { RadioTile, TileGroup } from "carbon-components-svelte";
  import { optionsData } from "../../ts/Stores";
  import type { IColor } from "src/ts/Interfaces";

  let colorCombos: IColor[][];
  let selectedIndex: string;
  export let selectedCombo: IColor[];

  optionsData.subscribe((optionsData) => {
    colorCombos = optionsData.colorComboOptions.colorCombos;
    selectedCombo = optionsData.colorComboOptions.defaultColorCombo;
    selectedIndex = colorCombos
      .findIndex((val) => {
        return (
          val[0].code === selectedCombo[0].code &&
          val[1].code === selectedCombo[1].code
        );
      })
      .toString();
  });

  // let valueToStyle = (value: string[]): string => {
  //   let style = "background-image:linear-gradient(90deg,";
  //   let stopPoint = 0;
  //   let stopPointIncr = 100 / value.length;
  //   for (let i = 0; i < value.length; i++) {
  //     const color = value[i];
  //     style += `${value[i]} ${stopPoint}% ${(stopPoint += stopPointIncr)}%`;
  //     style += i === value.length - 1 ? "" : ",";
  //   }
  //   style += ")";
  //   return style;
  // };

  let valueToStyle = (value: IColor[]): string => {
    return `background-image:linear-gradient(90deg,${value[1].code},${value[1].code});color:${value[0].code}`;
  };

  let valueToTitle = (value: IColor[]): string => {
    return `${value[0].name} text on ${value[1].name} background`;
  };

  let getColorCombo = (selectedIndex) => {
    return colorCombos.at(selectedIndex);
  };

  $: selectedCombo = getColorCombo(selectedIndex);
</script>

<TileGroup bind:selected={selectedIndex} class="flex-wrap">
  {#each colorCombos as value, index}
    <RadioTile
      value={index.toString()}
      class="bg-colorCombo"
      style={valueToStyle(value)}
      title={valueToTitle(value)}
    >
      &uhblk;&uhblk;&uhblk;&uhblk;
      <br />
      &uhblk;&uhblk;&uhblk;
    </RadioTile>
  {/each}
</TileGroup>
